import { __assign, __extends } from "tslib";
import cn from 'classnames';
import debounce from 'lodash-es/debounce';
import React from 'react';
import { connect } from 'react-redux';
import { Link, Route, Switch, withRouter } from 'react-router-dom';
import { ARBITRARY_ID_INITIAL_DATA, DOMAIN_TYPE_ARBITRARY, SCREEN_SMALL_WIDTH_BREAKPOINT_PX, } from '../../../../consts';
import { domainAction, domainSelector } from '../../../domain/domain-redux';
import { config } from '../../config';
import { routes } from '../../routes';
import { url } from '../../url';
import { getClientConfig } from '../../utils/app-storage';
import { createDebugLogger, isInIframe } from '../../utils/app-utils';
import './App.scss';
var NoMatch = function () { return (React.createElement("div", { style: { padding: '20px' } },
    "Page not found. Continue to ",
    React.createElement(Link, { to: url.HOME() }, "homepage"),
    ".")); };
var AppClass = /** @class */ (function (_super) {
    __extends(AppClass, _super);
    function AppClass(props) {
        var _this = _super.call(this, props) || this;
        _this.debug = createDebugLogger('App');
        _this.state = { screenWidth: 0, screenHeight: 0 };
        _this.setScreenSize = function () {
            var screenWidth = window.innerWidth ||
                document.documentElement.clientWidth ||
                document.body.clientWidth;
            var screenHeight = window.innerHeight ||
                document.documentElement.clientHeight ||
                document.body.clientHeight;
            _this.setState({ screenWidth: screenWidth, screenHeight: screenHeight });
        };
        _this._debouncedSetScreenSize = debounce(_this.setScreenSize, 100);
        return _this;
    }
    AppClass.prototype.componentDidMount = function () {
        var _a, _b;
        var clientConfig = getClientConfig();
        this._setPageTitle(clientConfig.HTML_TITLE);
        window.addEventListener('resize', this._debouncedSetScreenSize);
        this.setScreenSize();
        var windowTopLocationHref;
        try {
            // browser security can block this call
            windowTopLocationHref = window.top.location.href;
        }
        catch (e) { }
        // save "system" initials ASAP... we may add some more later via BubbleChannel
        this.props.dispatch(domainAction.mergeModelsPayload((_a = {},
            _a[DOMAIN_TYPE_ARBITRARY] = (_b = {},
                _b[ARBITRARY_ID_INITIAL_DATA] = __assign(__assign({}, (clientConfig.INITIAL_DATA || {})), { __clientIsTopWindow__: !isInIframe(), __clientLocationHref__: window.location.href, __clientTopLocationHref__: windowTopLocationHref, __clientUserAgent__: navigator.userAgent, initialDataClientConfigMerged: true }),
                _b),
            _a)));
    };
    AppClass.prototype.componentWillUnmount = function () {
        window.removeEventListener('resize', this._debouncedSetScreenSize);
    };
    AppClass.prototype._setPageTitle = function (title) {
        if (title === void 0) { title = ''; }
        document.title = title;
    };
    AppClass.prototype._renderPageSwitchBasic = function () {
        var B = config.css.B('-app');
        var screenWidth = this.state.screenWidth;
        var parentScreenWidth = this.props.parentScreenWidth;
        var isSmallApp = screenWidth <= SCREEN_SMALL_WIDTH_BREAKPOINT_PX;
        var isSmallParent = parentScreenWidth <= SCREEN_SMALL_WIDTH_BREAKPOINT_PX;
        // no transitions
        return (React.createElement("div", { className: cn(B, {
                'app-smallwidth': isSmallApp,
                'parent-smallwidth': isSmallParent,
            }) }, this._renderSwitch()));
    };
    AppClass.prototype._renderSwitch = function () {
        // const Routes = this.routes;
        // prvy vyhrava - preto davam externe ako prve...
        return (React.createElement(Switch, { location: this.props.location },
            (AppClass.externalRoutes || []).map(function (route, i) {
                return React.createElement(Route, __assign({ key: i }, route));
            }),
            routes.map(function (route, i) {
                return React.createElement(Route, __assign({ key: i }, route));
            }),
            React.createElement(Route, { component: NoMatch })));
    };
    AppClass.prototype.render = function () {
        var _a;
        if (((_a = this.props.initialData) === null || _a === void 0 ? void 0 : _a.initialDataClientConfigMerged) !== true) {
            return null;
        }
        if (typeof AppClass.renderer === 'function') {
            var rendered = AppClass.renderer(this);
            // use only if returned anything other than undefined
            if (rendered !== void 0) {
                return rendered;
            }
        }
        return this._renderPageSwitchBasic();
    };
    return AppClass;
}(React.Component));
export { AppClass };
var mapStateToProps = function (state, ownProps) {
    var initialData = domainSelector.getInitialData(state);
    var uiState = domainSelector.getUIState(state) || {};
    var parentScreen = uiState.parent_screen_size || {};
    return {
        initialData: initialData,
        parentScreenWidth: parentScreen.screenWidth || 0,
        parentScreenHeight: parentScreen.screenHeight || 0,
    };
};
var mapDispatchToProps = function (dispatch, ownProps) {
    return ({
        dispatch: dispatch,
    });
};
var connected = connect(mapStateToProps, mapDispatchToProps)(AppClass);
export var App = withRouter(connected);
// export const App = withRouter(AppClass as any) as typeof AppClass;
// lebo react-loadable s defaultnym exportom vyzaduje menej roboty
export default App;
